import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI, {Message} from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import './assets/css/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/theme/index.css'
import {get, post} from './lib/ajax'
import Cookies from 'js-cookie'
import {UserInfo} from './lib/AppConstant'

Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$get = get
Vue.prototype.$post = post

NProgress.configure({showSpinner: false})
router.beforeEach((to, from, next) => {
  const userInfoStr = Cookies.get(UserInfo)
  let isLogined = false
  if (userInfoStr != null && userInfoStr.length > 0) {
    const userInfo = JSON.parse(userInfoStr)
    if (userInfo != null && userInfo.token != null) {
      isLogined = true
    }
  }
  if (to.meta.isAuthenticated === true && isLogined === false) {
    next({ name: 'Home', query: {isNeedLogin: true} })
    Message.warning('请先登录')
  } else {
    NProgress.start()
    next()
  }
})
router.afterEach(() => {
  NProgress.done()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js